export interface CEParamsI {
  fromCE: boolean;
  inbox: string | null;
}
class SearchParamsHelper {
  static _extractFromCE(params) {
    const fromCE = params.get('fromCE')
      ? JSON.parse(params.get('fromCE') as string)
      : false;
    return fromCE;
  }
  static isfromCE(location) {
    if (!location || !location.search) return false;
    const params = new URLSearchParams(location.search); // is this parsed?
    return SearchParamsHelper._extractFromCE(params);
  }

  static getCEParams(location): CEParamsI {
    if (!location || !location.search)
      return { fromCE: false, inbox: null };
    const params = new URLSearchParams(location.search); // is this parsed?
    const fromCE = SearchParamsHelper._extractFromCE(params);
    const inbox = params.get('inbox');
    return { fromCE, inbox };
  }
}

export default SearchParamsHelper;
